import axios from '../../utils/axios';

export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_IS_SUCCESS = 'FETCH_COMPANY_IS_SUCCESS';
export const FETCH_COMPANY_ERROR = 'FETCH_COMPANY_ERROR';
export const SET_NEXT_INTEGRATION = 'SET_NEXT_INTEGRATION';

const companyEndpoint = `${process.env.REACT_APP_API_URL}company`;

export const fetchCompanySuccess = company => dispatch =>
  dispatch({
    type: FETCH_COMPANY_SUCCESS,
    company
  });

export const fetchCompanyISSuccess = data => dispatch =>
  dispatch({
    type: FETCH_COMPANY_IS_SUCCESS,
    data
  });

export const companyError = error => dispatch =>
  dispatch({
    type: FETCH_COMPANY_ERROR,
    error
  });

export const setNextIntegration = data => dispatch =>
  dispatch({
    type: SET_NEXT_INTEGRATION,
    data
  });

export const fetchCompany = () => async dispatch => {
  try {
    const response = await axios.get(companyEndpoint);
    dispatch(fetchCompanySuccess(response.data));

    return response.data;
  } catch (error) {
    dispatch(companyError(error));
  }
};

export const fetchCompanyIntegrationSettings = () => async dispatch => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}company/integration-settings/translate`
    );
    dispatch(fetchCompanyISSuccess(response.data.data));

    return response.data;
  } catch (error) {
    dispatch(companyError(error));
  }
};
